import React, { useEffect, useState, useContext } from "react";
import { DonutChart, Spinner, Link } from "@abb/abb-common-ux-react";
import { ERROR_LISTOfAsset } from "../../../strings";
import { getassetModelLegendsColor } from "../../../util";
import { RootContext } from "../../../contexts/root-context";
import assetConfigData from "./asset-model-summary.json"

function AssetModelSummary() {
  const {startTS, endTS, rimData, rimLaodingData, selectedSubstation, selectedDevice } = useContext(RootContext);

  // Renamed setispin to setSpin for better convention and to address SonarQube S6754
  const [isSpin, setSpin] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [hiddenItems, setHiddenItems] = useState([]);
  const [hoverItem, setHoverItem] = useState();

  const processAssetModelSummaryData = () => {
    if (!rimData || rimData.length === 0) {
      setData([]);
      setSpin(false); // Use setSpin
      return;
    }

    try {
      const filteredData = rimData.filter(log => {
        const substationMatch = selectedSubstation ? log.substation === selectedSubstation : true;
        const deviceMatch = selectedDevice ? log.device_name === selectedDevice : true;
        return substationMatch && deviceMatch;
      });

      const deviceCounts = {};

      filteredData.forEach(item => {
        const device = item?.device_name;
        if (device) {
          deviceCounts[device] = (deviceCounts[device] || 0) + 1;
        }
      });

      const updatedData = Object.entries(deviceCounts).map(([key, value]) => ({
        key,
        value,
        label: key,
        color: getassetModelLegendsColor(key),
      }));

      setData(updatedData);
      setError(false);
    } catch (error) {
      console.error('Error processing asset model summary:', error);
      setError(true);
    } finally {
      setSpin(false); // Use setSpin
    }
  };

  useEffect(() => {
    setSpin(rimLaodingData); // Use setSpin
    if (!rimLaodingData) {
      processAssetModelSummaryData();
    }
  }, [startTS, endTS, rimData, rimLaodingData, selectedSubstation, selectedDevice ]);

  const totalValue = data.reduce((sum, item) => sum + item.value, 0);

  // Extracting nested ternary operations into an independent statement
  let content;
  if (isSpin) {
    content = <Spinner style={{ margin: "auto" }} color="dark-grey" size="small" />;
  } else if (error) {
    content = (
      <span className="error-text">
        {ERROR_LISTOfAsset.ERROR_FETCH_DATA}
        <br />
        <Link style={{ color: "#1f1f1f" }} onClick={processAssetModelSummaryData}>
          Retry
        </Link>
      </span>
    );
  } else if (data?.length > 0) {
    content = (
      <DonutChart
        style={{
          width: "100%",
          padding: "20px 0px",
          margin: "0px 20px",
        }}
        legendPosition="right"
        allowValueHiding={true}
        disableHoverOnChart={false}
        disableHoverOnLegend={false}
        valueText={`${hoverItem ? hoverItem.value : totalValue}`}
        description={assetConfigData.chartDescription}
        hiddenItems={hiddenItems}
        onHiddenItemsChanged={setHiddenItems}
        onHover={(item) =>
          setHoverItem(data.find((i) => i.key === item))
        }
        onBlur={() => setHoverItem(undefined)}
        data={data}
      />
    );
  } else {
    content = <p className="center-text-error">{ERROR_LISTOfAsset.ASSET_SUMMARY_EMPTY_DATA}</p>;
  }

  return (
    <div className="user-login-summary-container">
      {content}
    </div>
  );
}

export default AssetModelSummary;